import { useEffect } from "react";

export default function UsePageMetadata(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
} 
